<template lang="pug">
  div#activation
    km-form(:models="$data" tipDirection="bottom" :label-width=0 ref="form")
      km-form-item(:prop="'code'" :rules="rule" v-if="show")
        km-input.wp(
          v-for="i in 4"
          ref="input"
          v-model="codes[i-1]"
          textAlign="center"
          :key="i"
          @focus="focus(i-1)"
          @input="inpuhandle($event, i-1)"
          :autofocus="autofocus[i-1]"
          :disabled="type==='loading'"
          :maxlength="5"
          :showClearIcon="false"
        )
      <br/>
      div.goto(v-if="!show") 
        p.date VIP有效期至：{{date}}
        span {{time}}秒后自动跳转
      km-form-item
        km-button(size="max" @click="save" :type="type") {{ saveMessage }}
    div(v-if="show")
      p.tip1
        span 提示：可以在
        span.bold 《{{ pname }}学习卡》
        span 背面找到激活码哦
      img(src="/static/images/ic_card.png")
</template>

<script>
import emitter from '../../../ui/src/mixins/emitter.js'
import { activation } from '@/api'
import { setTimeout } from 'timers'
export default {
  mixins: [emitter],
  data() {
    return {
      pname: window.ConfigNew.header.name,
      codes: [],
      autofocus: [true],
      code: '',
      type: '',
      rule: [
        { required: true, message: this.$t('Login.Activation.requiredPh') },
        {
          validator: this.validator.bind(this)
        }
      ],
      show: true,
      saveMessage: this.$t('Login.Activation.save'),
      time: 3,
      interval: '',
      date: ''
    }
  },
  props: ['numberId'],
  methods: {
    inpuhandle(v, index) {
      if (v.length === 5 && this.$refs.input[index].$refs.input.selectionStart === 5) {
        this.$set(this.autofocus, index, false)
        this.$set(this.autofocus, index + 1, true)
      }
    },
    focus(index) {
      this.autofocus = []
      this.$set(this.autofocus, index, true)
    },
    goto() {
      this.$emit('perfectInfo', {
        type: 'perRegister',
        isPer: true
      })
    },
    save() {
      if (this.show) {
        this.$refs.form
          .validate()
          .then(() => {
            this.interval = setInterval(() => {
              this.time--
              if (this.time <= 0) {
                clearInterval(this.interval)
                this.goto()
              }
            }, 1000)
            this.dispatch('cover', 'changetitle', '恭喜，激活成功！', 'success')
            this.type = ''
            this.show = false
            this.saveMessage = '完善个人信息'
          })
          .catch(() => {
            this.type = ''
            this.saveMessage = this.$t('Login.Activation.save')
          })
      } else {
        this.goto()
      }
    },
    validator(rule, value, callback, source, options) {
      this.saveMessage = this.$t('Login.Activation.saveing')
      this.type = 'loading'
      activation({
        numberId: this.numberId,
        code: this.code
      })
        .then(res => {
          if (res.status) {
            this.date = res.data.vipExpired
            callback()
          } else {
            callback('激活码错误，请确认后重试')
          }
        })
        .catch(() => {
          callback(123)
        })
      // setTimeout()
    }
  },
  watch: {
    codes: {
      deep: true,
      handler(v) {
        this.code = v.join('')
      }
    }
  },
  mounted() {
    this.dispatch('cover', 'changetitle', this.$t('Login.Activation.title'))
    this.$nextTick(() => {
      this.$refs.input.forEach((i, index) => {
        i.$refs.input.onbeforepaste = 'console.log(1)'
        i.$refs.input.onpaste = (a, b) => {
          this.code = (
            this.code.slice(0, index * 5 + a.target.selectionStart) +
            a.clipboardData.getData('Text')
          )
            .replace(/[^A-Z0-9]/g, '')
            .slice(0, 20)
          this.$set(this.codes, 0, this.code.slice(0, 5))
          this.$set(this.codes, 1, this.code.slice(5, 10))
          this.$set(this.codes, 2, this.code.slice(10, 15))
          this.$set(this.codes, 3, this.code.slice(15, 20))
          setTimeout(() => {
            this.$set(this.autofocus, index, false)
            this.$set(this.autofocus, Math.ceil(this.code.length / 5) - 1, true)
          })
          return false
        }
      })
    })
  },
  destroyed() {
    clearInterval(this.interval)
  }
}
</script>

<style lang="less" scoped>
#activation {
  text-align: center;
}
#activation .wp {
  width: 74px;
  height: 56px;
  border-radius: 4px;
  margin-right: 10px;
}
p.date {
  margin-top: 7px;
  color: #999;
  font-size: 20px;
  line-height: 26px;
}
p.tip1 {
  margin-top: 84px;
  line-height: 20px;
  font-size: 14px;
  color: #999;
  .bold {
    font-weight: 600;
  }
}
img {
  margin-top: 36px;
}
.goto {
  margin-bottom: 40px;
  span {
    margin-top: 18px;
    color: #999;
    font-size: 14px;
    line-height: 10px;
    display: inline-block;
  }
}
</style>
<style>
#activation .wp input {
  font-size: 20px;
}
#activation .errortip.bottom {
  margin-top: 12px;
}
#activation .form-item {
  margin-bottom: 50px;
}
#activation .form-item input {
  padding-left: 0px;
  padding-right: 0px;
}
#activation .wp input[disabled] {
  background: #f4f4f4;
}
</style>



// WEBPACK FOOTER //
// src/components/login/components/activation.vue